import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-circle-reload-lined",
  "use": "rt-base-circle-reload-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-circle-reload-lined\"><path d=\"M922.6 205.1l-58.3 47C784.7 147.3 661.1 80 522.2 80 282.4 80 88.3 264 88 511.5 87.7 759.1 282.2 944 522.2 944c187.5 0 347.2-122.7 408-294.5 1.6-4.5-0.7-9.5-5.1-11l-58.6-20.8c-4.2-1.5-8.9 0.7-10.4 5.1-1.9 5.3-3.9 10.7-6.1 15.9-17.9 43.7-43.5 83-76.2 116.7s-70.7 60.2-113 78.7c-43.7 19.1-90.4 28.8-138.4 28.8-48.1 0-94.6-9.7-138.4-28.8-42.3-18.5-80.3-44.9-113-78.7-32.7-33.7-58.3-73-76.2-116.7-18.5-45.2-27.9-77.2-27.9-126.8s9.4-81.6 27.9-126.8c17.9-43.7 43.5-83 76.2-116.7s70.7-60.2 113-78.7c43.7-19.1 90.4-28.8 138.4-28.8 48.1 0 94.6 9.7 138.4 28.8 42.3 18.5 80.3 44.9 113 78.7 10.2 10.6 19.9 21.8 28.7 33.5L740.3 352c-5.5 4.4-3.6 13.3 3.1 15L925 412.9c5.2 1.3 10.2-2.8 10.2-8.2l0.8-193c-0.1-7-8.1-11-13.4-6.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/circle-reload-lined.svg
// module id = 1668
// module chunks = 228